export type Lang = "en" | "zh";

export const strings: Record<Lang, Record<string, string>> = {
  en: {
    ch0_title: "Photon",
    ch0_body: "The carrier of electromagnetism.",
    ch1_title: "W & Z",
    ch1_body: "Why neutrons become protons.",
    ch2_title: "Gluon",
    ch2_body: "The strongest force we know.",
    ch3_title: "Higgs",
    ch3_body: "Why anything has mass at all.",
    ch4_title: "Take control",
    ch4_body: "Click a boson, then click in space.",
    hud_reset: "Reset",
    hud_replay: "Replay tour",
    fallback_no_webgl: "Your browser does not support WebGL.",
    site_title: "Gauge Boson",
    site_desc:
      "An interactive Three.js journey through the gauge bosons of the Standard Model.",
  },
  zh: {
    ch0_title: "光子",
    ch0_body: "电磁相互作用的传递者。",
    ch1_title: "W 与 Z",
    ch1_body: "中子变为质子的缘由。",
    ch2_title: "胶子",
    ch2_body: "已知最强的相互作用。",
    ch3_title: "希格斯",
    ch3_body: "万物因之有质量。",
    ch4_title: "自由探索",
    ch4_body: "点选一个玻色子，再在空间中点击。",
    hud_reset: "重置",
    hud_replay: "重播之旅",
    fallback_no_webgl: "您的浏览器不支持 WebGL。",
    site_title: "规范玻色子",
    site_desc: "一段穿越标准模型规范玻色子的 Three.js 互动之旅。",
  },
};
